export default __webpack_public_path__ + "static/pic08-8d5bc5e2706edb0f234176232fda7b29.jpg";